var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 19.6 18.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#39af4f;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 19.6,
    height: 18.64
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Untitled-1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M19.06,8s0-.06,0-.09L15,1.16a2.08,2.08,0,0,0-1.79-1H6.37a2.08,2.08,0,0,0-1.79,1L.51,7.86s0,.06,0,.09a1.39,1.39,0,0,0-.4,1v8.63c0,.55.25.91.64.91H18.82c.38,0,.64-.36.64-.91V8.94a1.39,1.39,0,0,0-.4-1M5.77,1.88a.73.73,0,0,1,.6-.33h6.79a.73.73,0,0,1,.6.33l3.43,5.66H13l-1.29,3.65h-4L6.49,7.54H2.34Zm12.29,15.2H1.47V8.94h4l1,2.71a1.41,1.41,0,0,0,1.32.94h4a1.41,1.41,0,0,0,1.32-.94l1-2.71h4Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat-icon.3bccd5a0f960c3ca98e9f593062e81c7.svg";
export { ForwardRef as ReactComponent };